<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "configure",
      key: "configId",
      url: {
        get: "/admin/system/config",
        add: "/admin/system/config",
        edit: "/admin/system/config",
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "配置名称",
          name: "configName",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "配置键值",
          name: "configKey",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "配置类型",
          name: "state",
          value: 1,
          type: "select",
          width: "240px",
          dropList: [
            { value: 1, name: "文本" },
            { value: 2, name: "富文本" },
          ],
          rules: [{ required: true, trigger: "blur", type: "number" }],
          onChange: this.onChangeType,
        },
        {
          label: "配置内容",
          name: "configValue",
          value: "",
          type: "textarea",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "配置内容",
          name: "configValue1",
          value: "",
          type: "editor",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "系统内置",
          name: "configType",
          value: "",
          type: "select",
          width: "240px",
          dropList: [
            {
              value: "Y",
              name: "是",
            },
            {
              value: "N",
              name: "否",
            },
          ],
        },
        {
          label: "备注",
          name: "remark",
          value: "",
          type: "textarea",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
      ],
      forms: {},
    };
  },
  created() {},
   mounted() {
    this.onChangeType(1);
    this.forms.state = 1;
    this.items[this.getItemIndex("state")].value = 1;
  },
  methods: {
    onChangeType(val) {
      if (val == 1) {
        this.items[this.getItemIndex("configValue1")].type = "kong";
        this.items[this.getItemIndex("configValue")].type = "textarea";
      }
      if (val == 2) {
        this.items[this.getItemIndex("configValue1")].type = "editor";
        this.items[this.getItemIndex("configValue")].type = "kong";
      }
    },
    // 加载详情数据
    initData() {
      let configId = this.kv;
      $utils.api.load(`/admin/system/config/${configId}`, {}).then((res) => {
        if (res && res.data && res.data.state == 1) {
          this.forms = res.data;
          this.items[this.getItemIndex("state")].value = 1;
          this.items[this.getItemIndex("configValue1")].type = "kong";
          this.items[this.getItemIndex("configValue")].type = "textarea";
        }
        if (res && res.data && res.data.state == 2) {
          this.forms = res.data;
          this.forms.configValue1 = res.data.configValue;
          this.items[this.getItemIndex("state")].value = 2;
          this.items[this.getItemIndex("configValue1")].type = "editor";
          this.items[this.getItemIndex("configValue")].type = "kong";
        }
      });
    },
    //提交
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      if (this.forms.state == 1) {
        let q = this.forms;
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.sloading = true;
            $utils.api
              .load(
                `/admin/system/config`,
                q,
                this.action == "edit" ? "PUT" : "POST"
              )
              .then((res) => {
                this.sloading = false;
                if (res.status) {
                  $utils.toast.success("保存成功");
                  $utils.url.go(-1);
                }
              })
              .catch((e) => {
                this.sloading = false;
                $utils.toast.error("保存异常" + e.message);
              });
          }
        });
      }
      if (this.forms.state == 2) {
        let q = this.forms;
        q.configValue = this.forms.configValue1;
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.sloading = true;
            $utils.api
              .load(
                `/admin/system/config`,
                q,
                this.action == "edit" ? "PUT" : "POST"
              )
              .then((res) => {
                this.sloading = false;
                if (res.status) {
                  $utils.toast.success("保存成功");
                  $utils.url.go(-1);
                }
              })
              .catch((e) => {
                this.sloading = false;
                $utils.toast.error("保存异常" + e.message);
              });
          }
        });
      }
    },
  },
};
</script>
